import {toggle} from '../ui/utilities';
import '../../styles/templates/page.scss';

toggle.bind('.js-menu-trigger', '.js-menu-content');
